
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import ProfileLayout from '@Components/Layout/profile';
import EditProfileForm from '@Components/ProfilePage/EditProfileForm';
import { Wrapper } from '@Components/ProfilePage/ProfilePage.styled';
import { RINA } from '@Constants/ACL';
import useTranslation from 'next-translate/useTranslation';
import React, { useState } from 'react';

type Props = {};

const EditProfile = ({}: Props) => {
  const { t } = useTranslation('Profile');
  const [isFormSuccess, setIsFormSuccess] = useState<boolean>(false);
  return (
    <ProfileLayout seoData={{ title: 'Profile' }}>
      <Wrapper>
        <EditProfileForm setIsFormSuccess={setIsFormSuccess} />
      </Wrapper>
    </ProfileLayout>
  );
};

 async function _getStaticProps() {
  return {
    props: {
      ACL: {
        action: RINA,
      },
    },
  };
}

export default EditProfile;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/profile/edit',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  